export enum BoxesVariations {
  square = 'boxesSquare',
  rectangle = 'boxesRectangle',
  rectangleClusters = 'boxesRectangleClusters',
  colorCards = 'boxesColorCards',
  kpi = 'boxesKpi',
}
